import { render } from "./project-changer.vue?vue&type=template&id=4dc0be66"
import script from "./project-changer.vue?vue&type=script&lang=js"
export * from "./project-changer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__